module.exports = __webpack_public_path__ + "static/media/ah-haha.31c42aa7.mp3";